import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreatePostComponent } from 'src/app/tools/create-post/create-post.component';
import { FirebaseTSFirestore, Limit, OrderBy, Where } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { Timestamp } from 'rxjs';
import { ImageCropDialogComponent } from 'src/app/image-crop-dialog/image-crop-dialog.component';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { EditProfileDialogComponent } from 'src/app/edit-profile-dialog/edit-profile-dialog.component';
import { ChangeProfilePictureDialogComponent } from 'src/app/change-profile-picture-dialog/change-profile-picture-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserData } from 'src/app/models/user.model';
import { ChatService, Message } from 'src/app/services/chat.service';
import { PostData, CommentData, FirestoreTimestamp } from '../../models/post.model';
import { query, collection, getDocs, orderBy, limit, startAfter, DocumentSnapshot, Firestore, getFirestore } from 'firebase/firestore';

interface Story {
  url: string;
  type: 'video' | 'image';
  duration?: number;
  thumbnail: string;
}

@Component({
  selector: 'app-video-feed',
  templateUrl: './video-feed.component.html',
  styleUrls: ['./video-feed.component.css']
})

export class VideoFeedComponent implements OnInit, AfterViewInit {
  @ViewChild('videoPlayer', { static: false }) videoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild('loadMoreTrigger') loadMoreTrigger: ElementRef;
  firestore = new FirebaseTSFirestore();
  firestore2: Firestore;
  auth = new FirebaseTSAuth();
  posts: PostData[] = [];
  userHasProfile = true;
  userData: any;

  username = "";
  profession = "";
  currentUser: UserData;
  coverPhotoUrl = "";
  profilePhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c";

  mutualFollowers: UserData[] = [];
  constructor(private dialog: MatDialog, private chatService: ChatService) { 
    this.firestore2 = getFirestore();
  }

  openChats: ChatWindow[] = [];

  activeVideo: HTMLVideoElement | null = null;

  private pageSize = 10;
  private lastDoc: DocumentSnapshot | null = null;
  public loading = false;
  public allLoaded = false;
  private loadingMore = false;
  private postIds = new Set<string>();

  ngOnInit(): void {
    this.getPosts();
    this.loadUserProfile();
  }

  ngAfterViewInit(): void {
    this.setupIntersectionObserver();
  }

  async getPosts() {
    if (this.loading || this.allLoaded) return;
    this.loading = true;

    try {
      let postsQuery = query(
        collection(this.firestore2, 'Posts'),
        orderBy('timestamp', 'desc'),
        limit(this.pageSize * 2)
      );

      if (this.lastDoc) {
        postsQuery = query(
          postsQuery,
          startAfter(this.lastDoc)
        );
      }

      const querySnapshot = await getDocs(postsQuery);

      if (!querySnapshot.empty) {
        this.lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

        const newPosts = querySnapshot.docs
          .map(doc => {
            const post = doc.data() as PostData;
            post.postId = doc.id;
            return post;
          })
          .filter(post => post.type === 'video' && !this.postIds.has(post.postId));

        newPosts.forEach(post => {
          this.posts.push(post);
          this.postIds.add(post.postId);
        });

        // Si on n'a pas assez de vidéos et qu'il y a plus de posts
        if (newPosts.length < this.pageSize && querySnapshot.docs.length >= this.pageSize * 2) {
          this.loadingMore = false;
          this.getPosts(); // Charger plus de posts
          return;
        }

        this.allLoaded = querySnapshot.docs.length < this.pageSize * 2;
      } else {
        this.allLoaded = true;
      }
    } catch (error) {
      console.error("Error fetching posts: ", error);
    } finally {
      this.loading = false;
      this.loadingMore = false;
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '200px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading && !this.allLoaded) {
          this.loadingMore = true;
          this.getPosts();
        }
      });
    }, options);

    setTimeout(() => {
      const target = document.querySelector('#infinite-scroll-trigger');
      if (target) observer.observe(target);
    }, 1000);
  }

  loggedIn() {
    return true;
  }

  onCreatePostClick() {
    this.dialog.open(CreatePostComponent);
  }

  loadUserProfile() {
    const userId = this.auth.getAuth().currentUser.uid; // Assurez-vous de récupérer l'ID utilisateur correctement
    this.firestore.getDocument({
      path: ["Users", userId],
      onComplete: result => {
        this.userData = result.data();

        // Logique pour récupérer les followers mutuels
        this.getMutualFollowers(this.auth.getAuth().currentUser.uid, this.userData.following).then(
          followers => {
            this.mutualFollowers = followers;
          }
        );

        if (this.userData?.profilePhotoUrl == "") {
          this.profilePhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c";
        } else {
          this.profilePhotoUrl = this.userData?.profilePhotoUrl;
        }

        if (this.userData?.coverPhotoUrl == "") {
          this.coverPhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf";
        } else {
          this.coverPhotoUrl = this.userData?.coverPhotoUrl;
        }


      },
      onFail: err => {
        console.error(err);
      }
    });


  }

  listenToChange() {
    this.firestore.listenToDocument(
      {
        name: "Getting Document",
        path: ["Users", this.auth.getAuth().currentUser.uid],
        onUpdate: (result) => {
          this.loadUserProfile();
        }
      }
    );
  }

  stories: Story[] = [
    /** { url: 'assets/video1.mp4', type: 'video', thumbnail: 'assets/images/img/m2.png' },
     { url: 'assets/video2.mp4', type: 'video', thumbnail: 'assets/images/img/m3.jpg' }, */
    { url: 'assets/images/img/feed1.jpeg', type: 'image', duration: 5, thumbnail: 'assets/images/img/story1.jpg' },
    { url: 'assets/images/img/feed3.png', type: 'image', duration: 5, thumbnail: 'assets/images/img/story2.jpg' },
    { url: 'assets/images/img/feed4.jpg', type: 'image', duration: 5, thumbnail: 'assets/images/img/story3.jpg' },
    { url: 'assets/images/img/feed2.jpg', type: 'image', duration: 5, thumbnail: 'assets/images/img/story4.jpg' },
    { url: 'assets/images/img/feedstory.jpeg', type: 'image', duration: 5, thumbnail: 'assets/images/img/story5.jpeg' }
  ];

  isStoryOpen = false;
  currentStoryIndex = 0;

  openStory(index: number): void {
    this.currentStoryIndex = index;
    this.isStoryOpen = true;
  }

  closeStory(): void {
    this.isStoryOpen = false;
  }

  openChat(user: UserData): void {
    this.openChatWindow(user);


  }

  // Ouvrir une fenêtre de chat
  openChatWindow(user: UserData): void {

    // Vérifier si la fenêtre de chat est déjà ouverte
    const chatAlreadyOpen = this.openChats.some(chat => chat.userData.uid === user.uid);

    //alert("Bonjour");
    if (!chatAlreadyOpen) {

      const newChatWindow: ChatWindow = {
        userData: user,       // Utilisez l'objet `UserData` pour la propriété `userData`
        newMessage: '',       // Initialise `newMessage` à une chaîne vide
        messages: []          // Initialise `messages` à un tableau vide
      };
      this.openChats.push(newChatWindow); // Ajouter l'utilisateur à la liste des chats ouverts

      const listenerName = `GetChatMessages_${this.auth.getAuth().currentUser.uid}_${user.uid}`;

      // Récupérer les messages pour ce chat
      const currentUserId = this.auth.getAuth().currentUser.uid;  // Remplacer par l'ID réel de l'utilisateur connecté
      this.chatService.getMessages2(currentUserId, user.uid, listenerName)
        .then(messages => {
          const chatUser = this.openChats.find(openChat => openChat.userData.uid === user.uid);

          if (chatUser) {
            chatUser.messages = messages;
          } // Stocker les messages dans l'objet utilisateur
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des messages:', error);
        });
    }
  }

  // Méthode appelée lorsque l'utilisateur veut envoyer un message à l'utilisateur d'une publication
  onMessageUser(user: UserData) {
    this.openChatWindow(user);
  }

  // Fermer une fenêtre de chat
  closeChatWindow(user: UserData): void {
    const listenerName = `GetChatMessages_${this.auth.getAuth().currentUser.uid}_${user.uid}`;
    this.chatService.closeChatWindow2(user.uid, listenerName);
    this.openChats = this.openChats.filter(chat => chat.userData.uid !== user.uid);
  }

  sendMessage(chatWindow: ChatWindow) {
    const currentUserId = this.auth.getAuth().currentUser.uid;  // Remplacez par l'ID réel de l'utilisateur connecté
    //const chatId = this.chatService.getChatId(currentUserId, chatWindow.userData.uid);

    if (chatWindow.newMessage && chatWindow.newMessage.trim() !== '') {

      this.chatService.sendMessage(currentUserId, chatWindow.userData.uid, chatWindow.newMessage.trim()).then(() => {
        // Réinitialiser la valeur de newMessage après envoi
        //newMessage = '';
        //this.userData.newMessage = '';
        chatWindow.newMessage = '';

      })
        .catch(error => {
          console.error('Erreur lors de l\'envoi du message:', error);
        });;
    }
  }

  // Récupérer les followers mutuels
  getMutualFollowers(currentUserId: string, following: string[]): Promise<UserData[]> {
    return new Promise((resolve, reject) => {
      const mutualFollowers: UserData[] = [];
      const chunkedFollowing: string[][] = [];

      // Diviser 'following' en sous-tableaux de 10 éléments maximum
      for (let i = 0; i < following.length; i += 10) {
        chunkedFollowing.push(following.slice(i, i + 10));
      }

      const promises = chunkedFollowing.map((chunk, index) => {
        // Générer un nom unique en utilisant un identifiant aléatoire (UUID) ou un compteur d'index
        const listenerName = `GetMutualFollowers_${index}_${Date.now()}`;

        return new Promise<void>((chunkResolve, chunkReject) => {
          this.firestore.listenToCollection({
            name: listenerName,
            path: ["Users"],
            where: [new Where('uid', 'in', chunk)],
            onUpdate: (result) => {
              result.docs.forEach((doc) => {
                const user = <UserData>doc.data();
                const followers = doc.data()?.followers || [];
                if (followers.includes(currentUserId)) {
                  mutualFollowers.push(user);
                }
              });
              chunkResolve();
            },

          });
        });
      });

      Promise.all(promises)
        .then(() => {
          this.mutualFollowers = mutualFollowers;
          resolve(mutualFollowers);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // Méthode appelée lorsque une vidéo est jouée dans un PostComponent
  onVideoPlayed(video: HTMLVideoElement) {
    if (this.activeVideo && this.activeVideo !== video) {
      // Si une autre vidéo est déjà en cours de lecture, elle est mise en pause
      this.activeVideo.pause();
    }

    // La vidéo actuellement jouée devient la nouvelle vidéo active
    this.activeVideo = video;
  }
}

export interface ChatWindow {
  userData: UserData;
  newMessage: string;
  messages: Message[];
}
